<template>
  <div>
    <div class="button">
      <a-icon type="shrink" style="font-size: 18px" />
      <div>平移</div>
      <div class="direction">
        <a-icon type="up" class="up" @click="goUp" />
        <a-icon type="left" class="left" @click="goLeft" />
        <a-icon type="right" class="right" @click="goRight" />
        <a-icon type="down" class="down" @click="goDown" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("mapTools", ["up", "down", "left", "right"]),
  },
  methods: {
    ...mapMutations("mapTools", ["setUp", "setDown", "setLeft", "setRight"]),
    goUp() {
      this.setUp(this.up + 1);
    },
    goLeft() {
      this.setLeft(this.left + 1);
    },
    goRight() {
      this.setRight(this.right + 1);
    },
    goDown() {
      this.setDown(this.down + 1);
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #999;
  font-size: 12px;
  position: relative;
  .direction {
    display: none;
  }
  &:hover {
    .direction {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      display: block;

      .up {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .down {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .left {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
      }
      .right {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}
</style>